import {observer} from "mobx-react";
import {CustomerFilterAutoComplete, FieldDateSwitch2, FieldDateSwitchValue} from "../../ui";
import {updateUrlOnDateSwitchChange} from "../../../utils";
import {useState} from "react";
import {useSearchParams} from "react-router";
import {kpiCustomerStore} from "../../../store";

const DashboardFilterBar = observer(function DashboardFilterBar() {
    const [searchParams, setSearchParams] = useSearchParams()


    const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
    const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
    const [from, setFrom] = useState<FieldDateSwitchValue | undefined>(fromS ? {
        absolute: searchParams.get('fromAbsolute') || undefined,
        relative: searchParams.get('fromRelative') || undefined,
    } : undefined)
    const [to, setTo] = useState<FieldDateSwitchValue | undefined>(toS ? {
        absolute: searchParams.get('toAbsolute') || undefined,
        relative: searchParams.get('toRelative') || undefined,
    } : undefined)

    return <>
        <div style={{
            display: 'flex',
            zoom: '85%',
            alignItems: 'flex-start',
            borderBottom: '1px solid var(--bulma-border)',
            zIndex: 1
        }}>
            <div style={{
                minWidth: '2em',
                maxWidth: '15em',
                marginRight: '1em'
            }}>
                <CustomerFilterAutoComplete
                    items={kpiCustomerStore.items}
                    search={kpiCustomerStore.search}
                    param={'customerId'}/>
            </div>
            <div style={{
                minWidth: '2em',
                maxWidth: '7.5em',
                marginRight: '1em'
            }}>
                <FieldDateSwitch2
                    label={"Von"}
                    value={from}
                    onChange={v => {
                        updateUrlOnDateSwitchChange(v, 'from', searchParams, setSearchParams)
                        setFrom(v)
                    }}
                />
            </div>
            <div style={{
                minWidth: '2em',
                maxWidth: '7.5em'
            }}>
                <FieldDateSwitch2
                    label={"Bis"}
                    value={to}
                    onChange={v => {
                        updateUrlOnDateSwitchChange(v, 'to', searchParams, setSearchParams)
                        setTo(v)
                    }}
                />
            </div>
        </div>
    </>
})

export {
    DashboardFilterBar
}
